import React from 'react';
import Icon from '../../../components/AppIcon';

const FourGuidesSection = () => {
  const guides = [
    {
      icon: 'Sunrise',
      title: 'Morning Intentions',
      description: 'Set the tone for your day.',
      gradient: 'from-orange-500/20 to-yellow-500/20'
    },
    {
      icon: 'Moon',
      title: 'Shadow Work',
      description: 'Meet triggers with awareness.',
      gradient: 'from-purple-500/20 to-indigo-500/20'
    },
    {
      icon: 'Target',
      title: 'Vision Quest',
      description: 'Reinforce the future you want.',
      gradient: 'from-blue-500/20 to-cyan-500/20'
    },
    {
      icon: 'Stars',
      title: 'Night Reflections',
      description: 'Close the day with insight.',
      gradient: 'from-indigo-500/20 to-violet-500/20'
    }
  ];

  return (
    <section className="py-12 px-6 relative">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">
            The four guides
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {guides?.map((guide, index) => (
            <div
              key={guide?.title}
              className="group relative glassmorphism p-5 rounded-xl hover-lift transition-all duration-300 flex items-start space-x-4"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${guide?.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl`} />
              <div className="relative z-10 flex items-start space-x-4">
                <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${guide?.gradient} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={guide?.icon} size={20} className="text-foreground" />
                </div>
                <div>
                  <h3 className="text-sm font-bold text-foreground mb-1">{guide?.title}</h3>
                  <p className="text-xs text-muted-foreground">{guide?.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FourGuidesSection;
